export default "__VITE_PUBLIC_ASSET__2f9e77e9__"